import markAWBInvalid from '../views/markAWBInvalid'
import changeinvoicequantity from '../views/changeinvoicequantity'
import pendingEWBN from '../views/pendingEWBN'
import updateInvoiceDetails from '../views/updateInvoiceDetails'
import changephysicalweight from '../views/changephysicalweight';
import ebnexpirylist from '../views/ebnexpirylist';
import changereattemptdate from '../views/changereattempdate';
import Markshipmentinvalidonchild from '../views/Markshipmentinvalidonchild';
import mpslist from '../views/mpslist';
import pushmissingparentdata from '../views/pushmissingparentdata';
import pendingawbverification from '../views/pendingawbverification';
import updateFTCcharges from '../views/updateFTCcharges';
import inscanshortshipment from '../views/inscanshortshipment';
import changeassignedsr from '../views/changeassignedsr';
import AirWalletTransactions from '../views/airwallettransactions'
import updateBookingDetails from '../views/updateBookingDetails';
import tspbausers from '../views/tspbausers/tspbauserslisting';
import ProofOfPickup from '../views/proofofpickup';
import pushMissingPod from '../views/pushMissingPOD';

export default [
	{
	  path: '/markAWBInvalid',
	  name: 'markAWBInvalid',
	  component: markAWBInvalid,
	  title: 'markAWBInvalid',
	  meta: {
	    requiresAuth: true
	  }
	},
	{
	  path: '/pendingewbn',
	  name: 'pendingEWBN',
	  component: pendingEWBN,
	  title: 'pendingEWBN',
	  meta: {
	    requiresAuth: true
	  }
	},
	{
		path: '/updateInvoiceDetails',
		name: 'updateInvoiceDetails',
		component: updateInvoiceDetails,
		title: 'updateInvoiceDetails',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/changephysicalweight',
		name: 'changephysicalweight',
		component: changephysicalweight,
		title: 'changephysicalweight',
		meta: {
			requiresAuth: true
		  }
	},
	{
		path: '/changeinvoicequantity',
		name: 'changeinvoicequantity',
		component: changeinvoicequantity,
		title: 'changeinvoicequantity',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/ebnexpirylist',
		name: 'ebnexpirylist',
		component: ebnexpirylist,
		title: 'ebnexpirylist',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/changereattemptdate',
		name: 'Change Reattempt Date',
		component: changereattemptdate,
		title: 'changereattemptdate',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/markshipmentinvalidonchild',
		name: 'Markshipmentinvalidonchild',
		component: Markshipmentinvalidonchild,
		title: 'Markshipmentinvalidonchild',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/mpslist',
		name: 'MPS List',
		component: mpslist,
		title: 'mpslist',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/pushmissingparentdata',
		name: 'pushmissingparentdata',
		component: pushmissingparentdata,
		title: 'pushmissingparentdata',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/pendingawbverification',
		name: 'pendingawbverification',
		component: pendingawbverification,
		title: 'pendingawbverification',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/inscanshortshipment',
		name: 'inscanshortshipment',
		component: inscanshortshipment,
		title: 'inscanshortshipment',
		meta: {
			requiresAuth: true
		  }
	},
	{
		path: '/changeassignedsr',
		name: 'changeassignedsr',
		component: changeassignedsr,
		title: 'changeassignedsr',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/updatecashmemo',
		name: 'updatecashmemo',
		component: updateFTCcharges,
		title: 'updatecashmemo',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/updatebookingdetails',
		name: 'updatebookingdetails',
		component: updateBookingDetails,
		title: 'updatebookingdetails',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/wallettransaction',
		name: 'wallettransaction',
		component: AirWalletTransactions,
		title: 'wallettransaction',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/tspbausers',
		name: 'tspbausers',
		component: tspbausers,
		title: 'tspbausers',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/proofofpickup',
		name: 'ProofOfPickup',
		component: ProofOfPickup,
		title: 'ProofOfPickup',
		meta: {
			requiresAuth: true
		}
	},
	{

	
		path: '/pushMissingPOD',
		name: 'pushMissingPOD',
		component:pushMissingPod,
		title: 'pushMissingPOD',
		meta: {
			requiresAuth: true
		}
	}
]



// WEBPACK FOOTER //
// ./src/modules/utility/router/index.js